import React, { useEffect, useState, Fragment, useContext } from "react";
import Panel from "../Panel";
import {
  Form,
  FormInput,
  Grid,
  GridColumn,
  GridRow,
  FormGroup,
  Divider,
  Dropdown,
  Button,
  Message,
  FormField,
  Checkbox,
} from "semantic-ui-react";
import { useFormik } from "formik";
import "../OrderComponents/ZenMigration.css";
import "react-datepicker/dist/react-datepicker.css";
import { AppointmentComponent } from "./ZenAppointmentComponent";
import { ActivationDate } from "./ActivationDate";
import postZenOrder from "../../libs/requests/postZenOrder";
import { selectErrorBannerMessage } from "../../libs/zenErrorBannerMessage";
import * as utilities from "./Utilities";
import { AppointmentRequiredComponent } from "./ZenAppointmentRequired";
import addressSearchRequest from "../../libs/requests/addressSearch";
import { getRealms } from "../../libs/requests/getPartnerDetails";
import { checkUsernameValid } from "../../libs/utils";
import AccessLinesSection from "./AccessLinesSection";
import moment from "moment-timezone";
import ProvisionTypeSection from "./ProvisionTypeSection";
import handleAddressChange from "./AddressChange";
import ContractTermSection from "./ContractTermSection";
import { generateShortID } from "../../libs/utils";
import { authContext } from "../../containers/AuthProvider";
import { fetchAppointmentDetails } from "./Utilities";

export default function SogeaOrder({ storage, postOrder = postZenOrder }) {
  const [product, setProduct] = useState(storage);
  const [productName, setProductName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [requestPhone, setRequestPhone] = useState("");
  const [email, setEmail] = useState("");
  const [postCode, setPostCode] = useState("");

  const [isLoading, setIsLoading] = React.useState(false);
  const [level, setLevel] = React.useState({ careLevelField: "Standard" });
  const [weighting, setTrafficWeighting] = React.useState({
    trafficWeightingField: "Standard",
  });
  const [zenReference, setZenReference] = React.useState();
  const [errorMessage, setErrorMessage] = React.useState([]);
  const [usernameMessage, setUsernameMessageResults] = React.useState("");
  const [usernameValue, setUsernameValue] = React.useState("");
  const [radioButtons, setRadioButtons] = React.useState("0");
  const [addressResults, setAddressResults] = React.useState([]);
  const [supplier, setSupplier] = React.useState("");
  const [isAppointmentRequired, setIsAppointmentRequired] =
    React.useState(false);
  const [provisionType, setProvisionType] = React.useState();
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addressValue, setAddressValue] = useState({
    addressField: {
      addressReferenceNumber: "",
      districtCode: "",
      qualifier: "",
    },
  });
  const [realm, setRealm] = useState();
  const [realms, setRealms] = useState([]);
  const [isL2Customer, setIsL2Customer] = useState(false);
  const [gatherers, setGatherers] = useState([]);
  const [validators, setValidators] = useState([]);
  const [accessLines, setAccessLines] = useState();
  const [minLeadDate, setMinLeadDate] = useState(null);
  const [overrideShowAppointments, setOverrideShowAppointments] =
    useState(false);
  const [hasSelectedNewProvide, setHasSelectedNewProvide] = useState(false);
  const [hasSelectedAccessLine, setHasSelectedAccessLine] = useState(false);
  const [workingLineTakeover, setWorkingLineTakeover] = useState(false);
  const [selectedLine, setSelectedLine] = useState(null);
  const [selectedContractTerm, setSelectedContractTerm] = useState();
  const [isRetryOrder, setIsRetryOrder] = useState(false);
  const { logout, userLoggedIn, permissions } = useContext(authContext);
  const [pricingOption, setPricingOption] = useState("rateCard");
  const [bespokePrice, setBespokePrice] = useState("");
  const [selectedAppointmentType, setSelectedAppointmentType] = useState(null);
  const [router, setSelectedRouter] = useState("None");
  const [productOptions, setProductOptions] = useState([]);
  const [requierments, setRequierments] = useState([]);
  const [deliveryOptions, setSelectedDelivery] = useState("");
  const [showDeliveryValidation, setShowDeliveryValidation] = useState(false);
  const [isBureauReseller, setIsBureauReseller] = useState(false);
  const [appointmentList, setAppointmentList] = useState([]);
  const [bureauEndCustomer, setBureauEndCustomer] = useState("");

  const handleBureauResellerChange = (e, { checked }) => {
    setIsBureauReseller(checked);
    setFieldValue("isBureauReseller", checked);
    // Clear end customer field when unchecked
    if (!checked) {
      setBureauEndCustomer("");
      setFieldValue("bureauEndCustomer", "");
    }
    // Trigger validation
    setTimeout(() => formik.validateForm(), 0);
  };

  useEffect(() => {
    const loadAppointments = async () => {
      const details = sessionStorage.getItem("selectedProduct");
      const data = await fetchAppointmentDetails(details);
      if (data) setAppointmentList(data);
    };

    loadAppointments();
  }, [selectedAppointmentType]); 


  const handleBureauEndCustomerChange = (e) => {
    setBureauEndCustomer(e.target.value);
    setFieldValue("bureauEndCustomer", e.target.value);
  };

  useEffect(() => {
    const initialTerm = permissions?.isNimansTenant ? 12 : 1;
    setSelectedContractTerm(initialTerm);
    if (handleContractTermChange) {
      handleContractTermChange(initialTerm);
    }
  }, [permissions?.isNimansTenant]);

  const handleAppointmentTypeChange = (type) => {
    setSelectedAppointmentType(type);
  };

  const handlePricingOptionChange = (e, { value }) => {
    setPricingOption(value);
  };

  const handlePriceChange = (e) => {
    setBespokePrice(e.target.value);
    setFieldValue("bespokePrice", e.target.value);
  };

  const handleRetryChange = () => {
    setIsRetryOrder((prev) => !prev);
  };

  const handleContractTermChange = (term) => {
    setSelectedContractTerm(term);
  };

  useEffect(() => {
    if (storage && storage.selectedProduct) {
      const selectedProductObject = JSON.parse(storage.selectedProduct);
      const selectedPhone = JSON.parse(storage.customerDetails);
      const orderDetails = selectedProductObject.orderDetails;
      const requierments = selectedProductObject?.requierments || [];

      setProductName(selectedProductObject.productName);
      setProductCode(selectedProductObject.productCode);
      setRequestPhone(selectedPhone.phoneNumber);
      setEmail(storage.email);
      setProduct(selectedProductObject);
      setPostCode(getPostCode(orderDetails));
      setAccessLines(orderDetails.accessLines);
      setProductOptions(orderDetails?.productOptions || []);
      setRequierments(requierments || []);
    }
  }, [storage]);

  const handleRequiredChange = (required) => {
    setIsAppointmentRequired(required);
  };

  function getPostCode(orderDetails) {
    if (orderDetails?.requestPostCode) {
      setPostCode(orderDetails?.requestPostCode);
      return orderDetails?.requestPostCode;
    }
    return (
      orderDetails?.lineCharacteristics?.btOpenreachPostCode ||
      orderDetails?.lineCharacteristics?.btWholesalePostCode ||
      ""
    );
  }

  const handleDeliveryChange = (e, { value }) => {
    setSelectedDelivery(value);
    setFieldValue("deliveryOptions", value);
    setTimeout(() => formik.validateForm(), 0);
  };

  const handleRouterChange = (e, { value }) => {
    setSelectedRouter(value);
    setFieldValue("router", value);
    setShowDeliveryValidation(value !== "None");
    if (value === "None") {
      setSelectedDelivery("");
      setFieldValue("deliveryOptions", "");
    }
    setTimeout(() => formik.validateForm(), 0);
  };

  useEffect(() => {
    console.log("Selected Line has changed to:", selectedLine);
  }, [selectedLine]);

  useEffect(() => {
    if (product && product.orderDetails) {
      setProvisionType(product?.orderDetails?.provision?.provisionType);
    }
  }, [product, provisionType]);

  useEffect(() => {
    async function fetchInitialData() {
      const defaultSupplier = await utilities.fetchSuppllier();
      setSupplier(defaultSupplier);
      const l2 = await utilities.isL2();
      setIsL2Customer(l2);

      if (!l2) {
        const realms = await getRealms();
        setRealms(realms);
        setRealm(realms[0]?.value);
      }
    }
    fetchInitialData();
  }, []);

  useEffect(() => {
    async function getAddressResults() {
      if (postCode) {
        await getAddresses(postCode).then((data) => setAddressResults(data));
      }
    }
    getAddressResults();
  }, [postCode]);

  const updateProvisionType = (newType) => {
    const provisionTypeMap = {
      NewProvide: 1,
      Migration: 2,
      NotAllowedToOrder: 3,
      SimProvide: 4,
      SuccessionProvide: 5,
      MigrationOrSuccessionProvide: 6,
      MigrationOrNewProvide: 7,
    };

    setProvisionType(newType);
    // Trigger validation after provision type is updated
    setTimeout(() => formik.validateForm(), 0);
  };

  const unRegisterValidator = (validator) => {
    setValidators((prevValidators) =>
      prevValidators.filter((v) => v !== validator)
    );
  };

  const unRegisterGatherer = (gatherer) => {
    setGatherers((prevGatherers) =>
      prevGatherers.filter((g) => g !== gatherer)
    );
  };

  const registerGatherer = (gatherer) => {
    setGatherers((prevGatherers) => [...prevGatherers, gatherer]);
  };

  const registerValidator = (validator) => {
    setValidators((prevValidators) => [...prevValidators, validator]);
  };

  const getAddresses = async (postCode) => {
    const result = await addressSearch(postCode);
    const optionsList = [];

    if (result) {
      result.forEach(function (element) {
        optionsList.push({
          key: element.addressReference,
          value: element.addressReference,
          text: element.address,
          flag: element.addressReference,
        });
      });
      return optionsList;
    }
  };

  const addressSearch = async (postCode) => {
    try {
      return await addressSearchRequest(postCode);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddressChange = (event, result) => {
    const { name, value } = result || event.target;
    setAddressValue({ ...addressValue, [name]: value });
    setFieldValue("addressField", value);
  };

  const handleCareLevelChange = (event, result) => {
    const { name, value } = result || event.target;
    setLevel({ ...level, [name]: value });
  };

  const handleTrafficWeightingChange = (event, result) => {
    const { name, value } = result || event.target;
    setTrafficWeighting({ ...weighting, [name]: value });
  };

  const handleRealmChange = async (event, result) => {
    const { value } = result || event.target;
    setRealm(value);
    setFieldValue("realm", value);

    setUsernameMessageResults(await checkUsernameValid(usernameValue, value));
  };

  const handleUsernameChange = async (e, result) => {
    setUsernameValue(e.currentTarget.value);
    setFieldValue("usernameField", e.currentTarget.value);

    setUsernameMessageResults(
      await checkUsernameValid(e.currentTarget.value, realm)
    );
  };

  const loadProvisionTypes = () => {
    const provisionTypeMap = {
      1: "NewProvide",
      2: "Migration",
      3: "NotAllowedToOrder",
      4: "SimProvide",
      5: "SuccessionProvide",
      6: "MigrationOrSuccessionProvide",
      7: "MigrationOrNewProvide",
    };

    const { ontDetails } = product?.orderDetails?.provision?.reference || "";

    const orderType = provisionTypeMap[provisionType] || "Unknown";

    return (
      <Fragment>
        <ProvisionTypeSection
          label={orderType}
          ontDetails={ontDetails}
          productType={product?.type}
          setMinLeadDate={setMinLeadDate}
          newProvide={(newProvide) => setOverrideShowAppointments(newProvide)}
          {...getCallbackProps()}
        />
      </Fragment>
    );
  };

  const addBusinessDays = (originalDate, numDaysToAdd) => {
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining = numDaysToAdd;
    let currentMoment = moment();
    let oneDayLeadTimeCutOff = moment("16:00 pm", "HH:mm a");

    if (
      daysRemaining === 10 &&
      currentMoment.isBefore(oneDayLeadTimeCutOff) &&
      currentMoment.format("dddd") !== "Saturday" &&
      currentMoment.format("dddd") !== "Sunday"
    ) {
      daysRemaining = daysRemaining - 1;
    }

    const newDate = originalDate.clone();

    while (daysRemaining > 0) {
      newDate.add(1, "days");
      if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
        daysRemaining--;
      }
    }

    return newDate;
  };

  const handleLineSelected = (line) => {
    const minLeadDate =
      line?.lineType === "StoppedLine"
        ? addBusinessDays(moment().startOf("day"), 1)
        : product?.orderDetails?.request?.minActivationDate;

    setHasSelectedNewProvide(
      line?.isNewProvide ||
        requierments?.some(
          (x) => x.name === "Appointment" && x.value === "Required"
        )
    );
    setHasSelectedAccessLine(!line?.isNewProvide);
    setOverrideShowAppointments(!!line?.isNewProvide);
    setWorkingLineTakeover(line?.isLineTakeover);
    setMinLeadDate(minLeadDate);
    setSelectedLine(line);
    // Trigger validation after line selection state changes
    setTimeout(() => formik.validateForm(), 0);
  };

  const loadProvisionTypeOptions = () => {
    const provisionTypeMap = {
      1: "NewProvide",
      2: "Migration",
      3: "NotAllowedToOrder",
      4: "SimProvide",
      5: "SuccessionProvide",
      6: "MigrationOrSuccessionProvide",
      7: "MigrationOrNewProvide",
    };

    const provisionTypeString = provisionTypeMap[provisionType];
    const isMigrationOrNew =
      provisionTypeString === "MigrationOrNewProvide" ||
      provisionTypeString === "NewProvide";
    const isNotFTTP = !productName?.includes("FTTP");
    const isSogeaMigration =
      provisionTypeString === "Migration" && productName?.includes("SOGEA");

    return (isMigrationOrNew && isNotFTTP) || isSogeaMigration ? (
      <Fragment>
        <AccessLinesSection
          accessLines={accessLines}
          productName={productName}
          onLineSelected={handleLineSelected}
          {...getCallbackProps()}
          onProvisionChange={updateProvisionType}
          selectedLine={selectedLine}
        />
      </Fragment>
    ) : (
      loadProvisionTypes()
    );
  };

  const handleRadioChange = (e) => {
    setRadioButtons(e.currentTarget.value);
    setFieldValue("noOfIps", e.currentTarget.value);
  };

  const getCallbackProps = () => {
    return {
      registerValidator: registerValidator,
      registerGatherer: registerGatherer,
      unRegisterValidator: unRegisterValidator,
      unRegisterGatherer: unRegisterGatherer,
    };
  };

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    isValid,
    errors,
    ...formik
  } = useFormik({
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const body = utilities.buildSogeaOrderPayload({
          values,
          product,
          selectedLine,
          postCode,
          addressResults,
          selectedAppointmentType,
          level,
          weighting,
          router,
          deliveryOptions,
          pricingOption,
          bespokePrice,
          isRetryOrder,
          isL2Customer,
          realm,
          permissions,
          productOptions,
          requierments,
          hasSelectedNewProvide,
          hasSelectedAccessLine,
          workingLineTakeover,
          selectedContractTerm,
          bureauEndCustomer,
          isBureauReseller
        });

        setErrorMessage([]);
        setZenReference(await postOrder(body));
        setErrorMessage([]);
      } catch (ex) {
        console.log(ex);
        setErrorMessage(selectErrorBannerMessage(ex));
      } finally {
        setIsLoading(false);
      }
    },
    validate,
    validateOnChange: true,
    validateOnMount: true,
    initialValues: {
      pricingOption: "rateCard",
      bespokePrice: "",
      siteInformation: "",
      addressField: {
        addressReferenceNumber: "",
        districtCode: "",
        qualifier: "",
      },
      noOfIps: "1",
      activationDateField: "",
      orderRef: "",
      contactName: "",
      contactTel: "",
      usernameField: "",
      password: "",
      rid: "",
      router: "None",
      deliveryOptions: "",
    },
  });

  function validate({
    contactName,
    contactTel,
    usernameField,
    password,
    addressField,
    noOfIps,
    orderRef,
    rid,
    isBureauReseller,
    bureauEndCustomer,
  }) {
    const errors = {};
    const address =
      addressField.qualifier === "Silver"
        ? addressField.uprn
        : addressField.addressReferenceNumber;

    // Check provision type validation
    const provisionTypeMap = {
      1: "NewProvide",
      2: "Migration",
      3: "NotAllowedToOrder",
      4: "SimProvide",
      5: "SuccessionProvide",
      6: "MigrationOrSuccessionProvide",
      7: "MigrationOrNewProvide",
    };

    // Handle both numeric and string provision types
    const provisionTypeString =
      typeof provisionType === "number"
        ? provisionTypeMap[provisionType]
        : provisionType;

    const isMigrationOrNew =
      provisionTypeString === "MigrationOrNewProvide" ||
      provisionTypeString === "NewProvide";
    const isNotFTTP = !productName?.includes("FTTP");
    const isSogeaMigration =
      provisionTypeString === "Migration" && productName?.includes("SOGEA");

    // Check if this is a scenario that requires user selection (from loadProvisionTypeOptions logic)
    const requiresSelection =
      (isMigrationOrNew && isNotFTTP) || isSogeaMigration;

    // Only show error if:
    // 1. No provision type is set at all, OR
    // 2. Requires selection but user hasn't made a choice (no line selected and not new provide)
    if (!provisionType) {
      errors.provisionType = "Please select a provision type";
    } else if (
      requiresSelection &&
      !hasSelectedNewProvide &&
      !hasSelectedAccessLine &&
      !selectedLine
    ) {
      errors.provisionType = "Please select a provision type option";
    }

    if (
      permissions?.isNimansTenant &&
      isBureauReseller &&
      (!bureauEndCustomer || !bureauEndCustomer.length)
    ) {
      errors.bureauEndCustomer =
        "End customer name is required for Bureau reseller orders";
    }

    if (
      !permissions.isNimansTenant &&
      (typeof rid == "undefined" || !rid.length)
    ) {
      errors.rid = true;
    }

    if (typeof contactName == "undefined" || !contactName.length) {
      errors.addressField = true;
    }

    if (typeof contactTel == "undefined" || !contactTel.length) {
      errors.addressField = true;
    }

    if (!address) {
      errors.addressField = true;
    }

    if (
      (typeof noOfIps == "undefined" && !isL2Customer) ||
      (!noOfIps.length && !isL2Customer)
    ) {
      errors.noOfIps = true;
    }

    if (typeof orderRef == "undefined" || !orderRef.length) {
      errors.orderRef = true;
    }

    if (!usernameField && !isL2Customer) {
      errors.username = true;
    }

    if (
      (!isL2Customer && typeof password == "undefined") ||
      (!isL2Customer && !password.length)
    ) {
      errors.password = true;
    }

    if (
      (values.router !== "None" && !values.deliveryOptions) ||
      (values.router !== "None" && values.deliveryOptions === "")
    ) {
      errors.deliveryOptions =
        "Delivery option is required when a router is selected";
    }

    return errors;
  }

  return (
    <>
      <Panel header={supplier + " " + productName}>
        {typeof errorMessage != "undefined" && errorMessage.length !== 0 && (
          <Message
            error
            header="There was some errors with your submission"
            list={errorMessage}
          />
        )}

        {zenReference && (
          <Message
            success
            header="Your submission was successful"
            content={"Order reference: " + zenReference}
          />
        )}
        <Form onSubmit={useFormik.handleSubmit} className="disabled">
          <Grid columns={1}>
            <GridRow>
              <GridColumn>
                <FormGroup>
                  <FormInput
                    style={{ width: "250px" }}
                    inline
                    label="Product"
                    name="productLabel"
                    data-testid="productCode"
                    disabled={true}
                    value={productCode}
                    required
                  />
                </FormGroup>
                <Divider></Divider>
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn>
                <FormGroup>
                  <Form.Field
                    inline
                    label="Provision Type"
                    name="provisionLabel"
                    data-testid="provisioningType"
                    required
                    error={errors.provisionType}
                  />
                </FormGroup>
                {errors.provisionType && (
                  <Message
                    error
                    content={errors.provisionType}
                    style={{ marginBottom: "1rem" }}
                  />
                )}
                <FormGroup>
                  <Form.Field style={{ margin: "auto" }}>
                    {loadProvisionTypeOptions()}
                  </Form.Field>
                </FormGroup>
                <Divider></Divider>
              </GridColumn>
            </GridRow>
          </Grid>
          <Grid>
            <GridRow>
              <GridColumn>
                <FormGroup>
                  <Form.Field
                    inline
                    name="addressLabel"
                    data-testid="addressDropDown"
                    label={"Address  - ".concat(postCode)}
                    disabled={true}
                    required
                  ></Form.Field>
                </FormGroup>
                <FormGroup>
                  <Dropdown
                    placeholder="Select Address"
                    fluid
                    search
                    selection
                    options={addressResults || []}
                    label="addressField"
                    id="addressField"
                    name="addressField"
                    onChange={(e, val) => {
                      handleAddressChange(
                        e,
                        val,
                        setAddressValue,
                        setFieldValue,
                        addressValue
                      );
                      const selected = addressResults.find(
                        (x) => x.value === val.value
                      );
                      setSelectedAddress(selected);
                    }}
                  />
                </FormGroup>
                {productOptions.length > 0 && <Divider></Divider>}
              </GridColumn>
            </GridRow>
          </Grid>
          <Grid>
            <GridRow>
              <GridColumn>
                {productOptions?.length > 0 && (
                  <>
                    <FormGroup>
                      <Form.Field
                        inline
                        label={"Product Options"}
                        name="optionsLabel"
                        data-testid="optionsLabel"
                      />
                    </FormGroup>
                  </>
                )}

                {productOptions?.length > 0 &&
                  productOptions.some((x) => x.code === "CareLevel") && (
                    <>
                      <FormGroup>
                        <Form.Field label="Care Level" required />
                      </FormGroup>
                      <Grid>
                        <Grid.Row centered>
                          <Grid.Column width={12}>
                            <Form>
                              <FormGroup>
                                <Dropdown
                                  inline
                                  placeholder="Select Care Level"
                                  fluid
                                  search
                                  selection
                                  options={utilities.careLevels}
                                  label="careLevelField"
                                  id="careLevelField"
                                  name="careLevelField"
                                  defaultValue={utilities.careLevels[0].value}
                                  onChange={handleCareLevelChange}
                                  value={level.careLevelField}
                                />
                              </FormGroup>
                            </Form>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </>
                  )}

                {productOptions?.some((x) => x.code === "TrafficWeighting") && (
                  <>
                    <FormGroup>
                      <Form.Field label="Traffic Weighting" required />
                    </FormGroup>
                    <Grid>
                      <Grid.Row centered>
                        <Grid.Column width={12}>
                          <Form>
                            <FormGroup>
                              <Dropdown
                                placeholder="Select Traffic Weighting"
                                fluid
                                search
                                selection
                                options={utilities.trafficWeighting}
                                label="trafficWeightingField"
                                id="trafficWeightingField"
                                name="trafficWeightingField"
                                defaultValue={
                                  utilities.trafficWeighting[0].value
                                }
                                onChange={handleTrafficWeightingChange}
                                value={weighting.trafficWeightingField}
                              />
                            </FormGroup>
                          </Form>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </>
                )}
                {!isL2Customer && (
                  <>
                    <Divider></Divider>
                    <FormGroup>
                      <Form.Field
                        style={{ width: "250px" }}
                        inline
                        label="Credentials"
                        name="credentials"
                        data-testid="credentialsLabel"
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormInput
                        style={{ width: "250px" }}
                        inline
                        label="Username"
                        name="usernameField"
                        data-testid="usernameField"
                        disabled={false}
                        onChange={handleUsernameChange}
                        values={values.usernameField}
                        required
                      />
                      <Dropdown
                        style={{
                          height: "38px",
                          padding: "7px",
                          minWidth: "200px",
                        }}
                        options={realms}
                        id="realm"
                        name="realm"
                        defaultValue={realm}
                        onChange={handleRealmChange}
                        value={realm}
                        data-testid="realmDropdown"
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormInput
                        style={{ width: "250px" }}
                        inline
                        label="Password"
                        name="password"
                        id="password"
                        data-testid="password"
                        value={values.password}
                        onChange={handleChange}
                        required
                      />
                    </FormGroup>
                    {usernameMessage.includes(
                      "The username should be a minimum of 3 characters"
                    ) && (
                      <span className="login__error">{usernameMessage}</span>
                    )}
                    {(usernameMessage.includes("Available") ||
                      usernameMessage.includes("NotAvailable") ||
                      usernameMessage.includes("Invalid")) && (
                      <span className="login__success">{usernameMessage}</span>
                    )}
                  </>
                )}
                {!hasSelectedNewProvide &&
                  (hasSelectedAccessLine || workingLineTakeover) && (
                    <Divider> </Divider>
                  )}
                <FormGroup>
                  <GridRow columns={1} centered>
                    <GridColumn>
                      {
                        <AppointmentRequiredComponent
                          isVisible={
                            requierments?.some(
                              (x) =>
                                x.name === "Appointment" &&
                                x.value === "Optional"
                            ) && !hasSelectedNewProvide
                          }
                          appointmentList={appointmentList}
                          onRequiredChange={handleRequiredChange}
                          allowedAppointmentTypes={product?.allowedAppointmentTypes}
                        />
                      }
                    </GridColumn>
                  </GridRow>
                </FormGroup>

                {!isL2Customer && (
                  <>
                    <Divider></Divider>
                    <FormGroup>
                      <Form.Field
                        inline
                        label="No of IP Addresses"
                        name="ipsLabel"
                        data-testid="ipsLabel"
                        required
                      />
                    </FormGroup>
                    <FormGroup>
                      <Form.Field>
                        <input
                          type="radio"
                          name="noOfIps"
                          value={utilities.ips[0].value}
                          defaultChecked
                          className="ui.radio"
                          onChange={(e) => handleRadioChange(e, setFieldValue)}
                        />
                      </Form.Field>
                      <label>1</label>
                      <Form.Field>
                        <input
                          type="radio"
                          name="noOfIps"
                          value={utilities.ips[1].value}
                          className="ui.radio"
                          onChange={(e, val) =>
                            handleRadioChange(e, val, setFieldValue)
                          }
                        />
                      </Form.Field>
                      <label>4</label>
                    </FormGroup>
                  </>
                )}

                {permissions?.rateCard && <Divider></Divider>}

                {permissions?.rateCard && (
                  <FormGroup>
                    <Form.Field label="Router" />
                    <Dropdown
                      placeholder="Select Router"
                      fluid
                      selection
                      options={utilities?.routerOptions}
                      value={router}
                      onChange={handleRouterChange}
                      data-testid="routerDropdown"
                    />

                    <Form.Field label="Delivery" required={router !== "None"} />
                    <Dropdown
                      placeholder="Select Delivery Option"
                      fluid
                      selection
                      options={utilities?.deliveryOptions}
                      value={deliveryOptions}
                      onChange={handleDeliveryChange}
                      error={showDeliveryValidation && !deliveryOptions}
                    />
                    {showDeliveryValidation && !deliveryOptions && (
                      <Message
                        error
                        content="Please select a delivery option"
                      />
                    )}
                  </FormGroup>
                )}

                {permissions?.isNimansTenant && (
                  <>
                    <Divider></Divider>
                    <FormGroup>
                      <Form.Field
                        inline
                        label="Bureau Reseller"
                        name="bureauResellerLabel"
                        data-testid="bureauResellerLabel"
                        
                      />
                    </FormGroup>
                    <FormGroup>
                      <Checkbox
                        label="This is a Bureau reseller order"
                        name="isBureauReseller"
                        checked={isBureauReseller}
                        onChange={handleBureauResellerChange}
                        data-testid="isBureauResellerCheckbox"
                        style={{ marginLeft: '20px' }} 
                      />
                    </FormGroup>

                    {isBureauReseller && (
                      <FormGroup>
                        <Form.Field
                          label="End Customer Name"
                          required
                          error={errors.bureauEndCustomer}
                        />
                        <Form.Input
                          placeholder="Enter end customer name for billing"
                          name="bureauEndCustomer"
                          value={bureauEndCustomer}
                          onChange={handleBureauEndCustomerChange}
                          data-testid="bureauEndCustomerInput"
                        />
                        {errors.bureauEndCustomer && (
                          <Message
                            error
                            content={errors.bureauEndCustomer}
                            style={{ marginTop: "0.5rem" }}
                          />
                        )}
                      </FormGroup>
                    )}
                  </>
                )}

                <Divider></Divider>
                <FormGroup>
                  <Form.Field label="Contact Details" required />
                </FormGroup>
                <Form.Field>
                  <Form.Input
                    placeholder="Enter Contact Name"
                    id="contactName"
                    name="contactName"
                    value={values.contactName}
                    onChange={handleChange}
                    data-testid="contactName"
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    placeholder="Enter Contact Telephone Number"
                    defaultCountry="GB"
                    id="contactTel"
                    name="contactTel"
                    value={values.contactTel}
                    onChange={handleChange}
                  />
                </Form.Field>
                <Divider></Divider>
                {!hasSelectedNewProvide && !isAppointmentRequired && (
                  <ActivationDate
                    show={!hasSelectedNewProvide && !isAppointmentRequired}
                    today={new Date()}
                    leadTimeDays={1}
                  />
                )}
                {hasSelectedNewProvide && (
                  <AppointmentComponent
                    isVisible={isAppointmentRequired || hasSelectedNewProvide}
                    today={new Date()}
                    leadTimeDays={10}
                    allowedAppointmentTypes={product?.allowedAppointmentTypes}
                    onAppointmentTypeChange={handleAppointmentTypeChange}
                    appointmentList={appointmentList}
                  />
                )}

                {}
                {hasSelectedNewProvide && <Divider></Divider>}

                <>
                  <FormGroup>
                    <Form.Field
                      inline
                      label="Contract Term"
                      name="contractTermLabel"
                      data-testid="contractTermLabel"
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <ContractTermSection
                      onContractTermChange={handleContractTermChange}
                      shouldHideOneMonthOption={permissions.isNimansTenant}
                    />
                  </FormGroup>

                  {!hasSelectedNewProvide && <Divider></Divider>}
                </>

                {hasSelectedNewProvide && <Divider></Divider>}

                {permissions?.rateCard && (
                  <>
                    <FormGroup>
                      <Form.Field
                        inline
                        label="Pricing Option"
                        name="pricingOptionLabel"
                        data-testid="pricingOptionLabel"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Form.Field>
                        <Form.Radio
                          label="Rate Card"
                          name="pricingOption"
                          value="rateCard"
                          checked={pricingOption === "rateCard"}
                          onChange={handlePricingOptionChange}
                        />
                      </Form.Field>
                      <Form.Field>
                        <Form.Radio
                          label="Bespoke"
                          name="pricingOption"
                          value="bespoke"
                          checked={pricingOption === "bespoke"}
                          onChange={handlePricingOptionChange}
                        />
                      </Form.Field>
                    </FormGroup>
                    {pricingOption === "bespoke" && (
                      <FormGroup>
                        <Form.Input
                          label="Bespoke Price"
                          placeholder="Enter price"
                          name="bespokePrice"
                          value={bespokePrice}
                          onChange={handlePriceChange}
                          type="number"
                          min="0"
                          step="0.01"
                        />
                      </FormGroup>
                    )}
                    <Divider></Divider>
                  </>
                )}

                {permissions?.pendingOrders && (
                  <Message info>
                    If retrying a pending order, please tick the box below and
                    enter the appropriate partner order reference.
                  </Message>
                )}

                <FormGroup>
                  <Form.Field
                    inline
                    label="References"
                    name="references"
                    data-testid="referencesLabel"
                    disabled={true}
                  />
                </FormGroup>

                {permissions?.pendingOrders && (
                  <FormGroup>
                    <Form.Checkbox
                      label="Retry Order"
                      name="isRetryOrder"
                      checked={isRetryOrder}
                      onChange={handleRetryChange}
                      data-testid="isRetryOrderCheckbox"
                    />
                  </FormGroup>
                )}

                <FormGroup>
                  <FormInput
                    inline
                    label="Order Reference"
                    name="orderRef"
                    data-testid="orderRefLabel"
                    disabled={false}
                    value={values.orderRef}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
                {!permissions?.isNimansTenant && (
                  <FormGroup>
                    <FormInput
                      inline
                      label="RID"
                      name="rid"
                      data-testid="ridLabel"
                      disabled={false}
                      value={values.rid}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                )}
                <Button
                  disabled={!isValid || zenReference || errors.provisionType}
                  className="button-primary"
                  floated="right"
                  content="Place Order"
                  onClick={handleSubmit}
                  loading={isLoading}
                  data-testid="placeOrderButton"
                />
              </GridColumn>
            </GridRow>
          </Grid>
        </Form>
      </Panel>
    </>
  );
}
